import { createService, z } from '@betty/toolkit/api';
import {
  WithdrawalConfirmationSchema,
  WithdrawSettingsSchema,
} from './WithdrawService.schemas';

export default {
  ...createService({
    getSettings: {
      method: 'GET',
      url: '/settings/withdrawal',
      responseSchema: WithdrawSettingsSchema,
    },
  }),
  ...createService(
    {
      confirm: {
        method: 'POST',
        url: ({ transactionId }: { transactionId: string }) =>
          `/withdrawal/${transactionId}/confirmation`,
        responseSchema: WithdrawalConfirmationSchema,
      },
      cancel: {
        method: 'POST',
        url: ({ transactionId }: { transactionId: string }) =>
          `/withdrawals/${transactionId}/cancel`,
        responseSchema: z.object({}).optional(),
      },
    },
    ({ userId }) => `/players/${userId}`,
  ),
};
